export default "__VITE_ASSET__C0UfNDsg__"